/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import OwlCarousel from 'react-owl-carousel'
import 'owl.carousel/dist/assets/owl.carousel.css'
import 'owl.carousel/dist/assets/owl.theme.default.css'
import Img from 'react-cloudinary-lazy-image'

const AboutComponent = () => {
  const responsive = {
    0: {
      items: 1,
    },
    600: {
      items: 2,
    },
    1000: {
      items: 3,
    },
  }

  return (
    <>
      <main>
        {/* Hero Area Start */}
        <div
          className="hero-area hero-height2 d-flex align-items-center"
          data-background="assets/img/hero/h2_hero.jpg"
        >
          <div className="container">
            <div className="row">
              <div className="col-xl-12">
                <div className="hero-cap text-center pt-100">
                  <h2>Tentang Kami</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Hero Area End */}
        {/* About Details Start */}
        <div className="about-details-area section-padding2">
          <div className="container">
            <div className="row">
              <div className="col-lg-5">
                <div className="about-tittle">
                  <h2>
                    Tentang <span style={{ color: '#ed8c3e' }}>Eggless</span>
                  </h2>
                </div>
              </div>
              <div className="col-lg-7">
                <div className="about-details mb-50">
                  <p className="pear1">
                    <span style={{ color: '#ed8c3e' }}>Eggless</span> adalah
                    suatu company yang bergerak di bidang jasa. atau lebih
                    tepatnya menjual jasa, yaitu jasa pembuatan website, mobile
                    apps, jasa software development, jasa design UI & UX
                  </p>
                </div>
              </div>
              <div className="col-lg-5">
                <div className="about-tittle">
                  <h2>
                    Kenapa <span style={{ color: '#ed8c3e' }}>Eggless</span>?
                  </h2>
                </div>
              </div>
              <div className="col-lg-7">
                <div className="about-details">
                  <p className="pear1">
                    Kenapa Harus Kami? karena kami dapat di andalkan dan juga
                    profesional dalam pengerjaan project yang telah di berikan.
                    jadi tunggu apa lagi? ayo mulai bisnis anda dengan kami.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="container">
            <div className="row">
              <div className="col-xl-12">
                <div className="hero-cap text-center pt-100">
                  <h1 style={{ fontWeight: 'bold' }}>
                    Team <span style={{ color: '#ed8c3e' }}>Eggless</span>
                  </h1>
                </div>
              </div>
            </div>
            <div className="row mt-5">
              <div className="col-lg-12">
                <OwlCarousel
                  className="owl-theme"
                  loop
                  autoplay={true}
                  responsiveClass={true}
                  responsive={responsive}
                >
                  <div
                    className="card card-eggless"
                    style={{
                      height: '400px',
                      marginLeft: '20px',
                      marginRight: '20px',
                      borderRadius: '20px',
                      border: '2px solid #ed8c3e',
                    }}
                  >
                    <div className="card-body" style={{ marginTop: '40px' }}>
                      <div className="text-center">
                        <Img
                          cloudName={'eggless'}
                          imageName={'farras_ehzdgi'}
                          fixed={{
                            width: 150,
                            height: 150,
                          }}
                          style={{
                            marginBottom: '10%',
                            borderRadius: '50%',
                            border: '2px solid #ed8c3e',
                          }}
                          alt={'profile_farras'}
                        />
                        <h6
                          className="card-title pt-3"
                          style={{ fontWeight: 'bold' }}
                        >
                          Muhammad Farras Jibran
                        </h6>
                        <h6 className="customer-designation text-muted m-0 mb-4">
                          Web Developer
                        </h6>
                        <a
                          href="https://github.com/farasjibran"
                          style={{ marginRight: 10 }}
                        >
                          <i
                            className="fab fa-github"
                            style={{ color: 'black' }}
                          ></i>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div
                    className="card card-eggless"
                    style={{ height: '400px' }}
                  >
                    <div className="card-body" style={{ marginTop: '40px' }}>
                      <div className="text-center">
                        <Img
                          cloudName={'eggless'}
                          imageName={'fauzan_y9j4ah'}
                          fixed={{
                            width: 150,
                            height: 150,
                          }}
                          style={{
                            marginBottom: '10%',
                            borderRadius: '50%',
                            border: '2px solid #ed8c3e',
                          }}
                          alt={'profile_fauzan'}
                        />
                        <h6
                          className="card-title pt-3"
                          style={{ fontWeight: 'bold' }}
                        >
                          Fauzan Maulana
                        </h6>
                        <h6 className="customer-designation text-muted m-0 mb-4">
                          Web Developer
                        </h6>
                        <a
                          href="https://github.com/fauzanmaulana"
                          style={{ marginRight: 10 }}
                        >
                          <i
                            className="fab fa-github"
                            style={{ color: 'black' }}
                          ></i>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div
                    className="card card-eggless"
                    style={{ height: '400px' }}
                  >
                    <div className="card-body" style={{ marginTop: '40px' }}>
                      <div className="text-center">
                        <Img
                          cloudName={'eggless'}
                          imageName={'rifat_szsyxb'}
                          fixed={{
                            width: 150,
                            height: 150,
                          }}
                          style={{
                            marginBottom: '10%',
                            borderRadius: '50%',
                            border: '2px solid #ed8c3e',
                          }}
                          alt={'profile_rifat'}
                        />
                        <h6
                          className="card-title pt-3"
                          style={{ fontWeight: 'bold' }}
                        >
                          Rifat Khadafy
                        </h6>
                        <h6 className="customer-designation text-muted m-0 mb-4">
                          Mobile Developer
                        </h6>
                        <a
                          href="https://github.com/godofsleepy"
                          style={{ marginRight: 10 }}
                        >
                          <i
                            className="fab fa-github"
                            style={{ color: 'black' }}
                          ></i>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div
                    className="card card-eggless"
                    style={{ height: '400px' }}
                  >
                    <div className="card-body" style={{ marginTop: '40px' }}>
                      <div className="text-center">
                        <Img
                          cloudName={'eggless'}
                          imageName={'faris_qulq4o'}
                          fixed={{
                            width: 150,
                            height: 150,
                          }}
                          style={{
                            marginBottom: '10%',
                            borderRadius: '50%',
                            border: '2px solid #ed8c3e',
                          }}
                          alt={'profile_faris'}
                        />
                        <h6
                          className="card-title pt-3"
                          style={{ fontWeight: 'bold' }}
                        >
                          Rafi Izzatul Risqu Faris
                        </h6>
                        <h6 className="customer-designation text-muted m-0 mb-4">
                          Mobile Developer
                        </h6>
                        <a
                          href="https://github.com/RafiIzzatulRizquFaris"
                          style={{ marginRight: 10 }}
                        >
                          <i
                            className="fab fa-github"
                            style={{ color: 'black' }}
                          ></i>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div
                    className="card card-eggless"
                    style={{ height: '400px' }}
                  >
                    <div className="card-body" style={{ marginTop: '40px' }}>
                      <div className="text-center">
                        <Img
                          cloudName={'eggless'}
                          imageName={'rizky_qow3cy'}
                          fixed={{
                            width: 150,
                            height: 150,
                          }}
                          style={{
                            marginBottom: '10%',
                            borderRadius: '50%',
                            border: '2px solid #ed8c3e',
                          }}
                          alt={'profile_rizky'}
                        />
                        <h6
                          className="card-title pt-3"
                          style={{ fontWeight: 'bold' }}
                        >
                          Rizky Firmansyah
                        </h6>
                        <h6 className="customer-designation text-muted m-0 mb-4">
                          Web Developer
                        </h6>
                        <a
                          href="https://github.com/rizkyfirmansyah14"
                          style={{ marginRight: 10 }}
                        >
                          <i
                            className="fab fa-github"
                            style={{ color: 'black' }}
                          ></i>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div
                    className="card card-eggless"
                    style={{ height: '400px' }}
                  >
                    <div className="card-body" style={{ marginTop: '40px' }}>
                      <div className="text-center">
                        <Img
                          cloudName={'eggless'}
                          imageName={'adji_kij4ww'}
                          fixed={{
                            width: 150,
                            height: 150,
                          }}
                          style={{
                            marginBottom: '10%',
                            borderRadius: '50%',
                            border: '2px solid #ed8c3e',
                          }}
                          alt={'profile_adji'}
                        />
                        <h6
                          className="card-title pt-3"
                          style={{ fontWeight: 'bold' }}
                        >
                          Achmad Setiadji Nugroho
                        </h6>
                        <h6 className="customer-designation text-muted m-0 mb-4">
                          Web Developer
                        </h6>
                        <a
                          href="https://github.com/achmadsetiadji"
                          style={{ marginRight: 10 }}
                        >
                          <i
                            className="fab fa-github"
                            style={{ color: 'black' }}
                          ></i>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div
                    className="card card-eggless"
                    style={{ height: '400px' }}
                  >
                    <div className="card-body" style={{ marginTop: '40px' }}>
                      <div className="text-center">
                        <Img
                          cloudName={'eggless'}
                          imageName={'bimo_uktlvu'}
                          fixed={{
                            width: 150,
                            height: 150,
                          }}
                          style={{
                            marginBottom: '10%',
                            borderRadius: '50%',
                            border: '2px solid #ed8c3e',
                          }}
                          alt={'profile_bimo'}
                        />
                        <h6
                          className="card-title pt-3"
                          style={{ fontWeight: 'bold' }}
                        >
                          Bimo Amanta Hidayat
                        </h6>
                        <h6 className="customer-designation text-muted m-0 mb-4">
                          Web Developer
                        </h6>
                        <a
                          href="https://github.com/bimoamnthdyt"
                          style={{ marginRight: 10 }}
                        >
                          <i
                            className="fab fa-github"
                            style={{ color: 'black' }}
                          ></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </OwlCarousel>
              </div>
            </div>
          </div>
        </div>
        {/* About Details End */}
        {/* Want To Work Start */}
        <div className="wantToWork-area wantToWork-area2 w-padding2">
          <div className="container">
            <div className="row align-items-center justify-content-between">
              <div className="col-xl-8 col-lg-8 col-md-8">
                <div className="wantToWork-caption wantToWork-caption2">
                  <h2>
                    Segera hubungi kami dan buat bisnis anda menjadi digital
                    dengan kami.
                  </h2>
                </div>
              </div>
              <div className="col-xl-4 col-lg-4 col-md-4">
                <a href="/contact" className="btn btn-black f-right">
                  contact us now
                </a>
              </div>
            </div>
          </div>
        </div>
        {/* Want To Work End */}
      </main>
    </>
  )
}

export default AboutComponent
